import { render, staticRenderFns } from "./TableRateplanSidebar.vue?vue&type=template&id=609cccf4&scoped=true&"
import script from "./TableRateplanSidebar.vue?vue&type=script&lang=js&"
export * from "./TableRateplanSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609cccf4",
  null
  
)

export default component.exports